module.exports = "<div class=Notices><div v-for=\"notice in notices\" transition=fadeInOutRight class=\"Notices__item animated\"><notice :icon=icons[notice.type] :state=states[notice.type] :notice.sync=notice></notice></div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/dialogs/notifications.vue
// module id = 416
// module chunks = 0